module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8n9n2n5r-226bf4aad5e7948b90cf3ff75df7efcb.svg";